import { Box } from "@mui/material";

export function Center(props: any) {
  const { children } = props;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100%"
    >
      {children}
    </Box>
  );
}
